/**
 * 진단 화면의 시각 표기(`mm:ss`). 상단 시계·반주 진행 시간·곡선 가로 눈금이 이 한
 * 포매터를 쓴다 — 셋이 서로 다른 모양이면 같은 순간이 화면에 두 가지로 적힌다.
 */
export const clock = (sec: number): string => {
  const whole = Math.max(0, Math.floor(sec));
  const mm = String(Math.floor(whole / 60)).padStart(2, '0');
  const ss = String(whole % 60).padStart(2, '0');
  return `${mm}:${ss}`;
};
